module.exports = __webpack_public_path__ + "img/part2-2.4813f322.png";